import {
  FaBuilding,
  FaUniversity,
  FaShoppingCart,
  FaHospital,
  FaRocket,
  FaIndustry,
  FaGraduationCap,
  FaTruck,
  FaMoneyBillWave,
  FaPlaneDeparture,
} from "react-icons/fa";
import "./Industries.css";

const industries = [
  { icon: <FaBuilding />, label: "Real Estate" },
  { icon: <FaMoneyBillWave />, label: "FinTech" },
  { icon: <FaShoppingCart />, label: "E-Commerce" },
  { icon: <FaHospital />, label: "Healthcare" },
  { icon: <FaRocket />, label: "SaaS & Startups" },
  { icon: <FaIndustry />, label: "Manufacturing" },
  { icon: <FaGraduationCap />, label: "Education" },
  { icon: <FaTruck />, label: "Logistics & Supply Chain" },
  { icon: <FaUniversity />, label: "Enterprise & Corporate" },
  { icon: <FaPlaneDeparture />, label: "Travel & Hospitality" },
];

const Industries = () => {
  return (
    <section
      className="oglitz-industries"
      aria-labelledby="oglitz-industries-title"
    >
      <div className="oglitz-industries__inner">
        <span className="oglitz-industries__badge">Industries Expertise</span>

        <h2 id="oglitz-industries-title">
          Industries We <span>Serve</span>
        </h2>

        <p className="oglitz-industries__desc">
          We deliver scalable, secure, and high-performance digital solutions
          across diverse industries worldwide.
        </p>

        <ul className="oglitz-industries__grid" role="list">
          {industries.map((item, index) => (
            <li key={index} className="oglitz-industries__card">
              <span className="oglitz-industries__icon">{item.icon}</span>
              <span className="oglitz-industries__label">{item.label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Industries;
